/* eslint jsx-a11y/href-no-hash: "off" */

import React from "react";
import { goToRecordScreen } from "./get-home-menu-options";
import {getSeenUnlocksFromLocalstorage} from './unlock-localstorage-operations.js'
import {getUserUnlocksCompletedKeys} from '../b5-unlocks/getUserUnlocks'

class ViewRecordButton extends React.Component {

  constructor() {
    super();

    const seenKeys = getSeenUnlocksFromLocalstorage();
    const userUnlockedKeys = getUserUnlocksCompletedKeys();

    this.state = {
      //Show notification if SEEN is less than total amount of unlocks
      isShowingNotification: seenKeys.length < userUnlockedKeys.length
    }
  }


  handleGoToRecordScreen(e) {
    e.preventDefault();
    goToRecordScreen();
  }

  renderNotification() {
    if (this.state.isShowingNotification) {
      const notificationStyle = {
        position: "absolute",
        left: "89%",
        top: "-1.2em",
        zIndex: 2,
        background: "#EE2828",
        border: "0.2em solid #FF4646",
        color: "white",
        padding: "0.4em",
        fontSize: "1em"
      };
      return (
        <span style={notificationStyle}>!</span>
      )
    }
    return null
  }

  render() {
    return (
      <span style={{display: "inline-block", position:"relative"}}>
        {this.renderNotification()}
        <a
          href="#"
          className="button small"
          onClick={this.handleGoToRecordScreen.bind(this)}
        >
          <span className="button--text">View Record</span>
        </a>
      </span>
    );
  }
}

export default ViewRecordButton;



// WEBPACK FOOTER //
// ./src/b5-home/ViewRecordButton.js